"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const businessCalculator_1 = __importDefault(require("@powerednow/shared/constants/businessCalculator"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
const math = require('@powerednow/shared/modules//utilities/math');
// eslint-disable-next-line no-redeclare
class JobItem extends complexData_1.default {
    static get allowedAssociations() {
        return {
            userTaxRate: {
                key: 'userTaxRate',
                instance: (0, modelLookup_1.complexFindModel)('UserTaxRate'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().vat_id,
                },
            },
            productCategory: {
                key: 'productCategory',
                instance: (0, modelLookup_1.complexFindModel)('ProductCategory'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().category_id,
                },
            },
            mediaGroup: {
                key: 'mediaGroup',
                instance: (0, modelLookup_1.complexFindModel)('MediaGroup'),
                single: true,
                cascadeDelete: false,
                condition: {
                    jobitem_id: this.Entity.getFieldSymbols().id,
                },
            },
            jobItemGroup: {
                key: 'jobItemGroup',
                instance: (0, modelLookup_1.complexFindModel)('JobItemGroup'),
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().jobitemgroup_id,
                },
            },
            company: {
                key: 'company',
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                single: true,
                condition: {
                    id: this.Entity.getFieldSymbols().company_id,
                },
            },
        };
    }
    async hasUserTaxRate() {
        return Boolean(await this.getUserTaxRate());
    }
    async isAllowed({ sourceCountryId, targetCountryId, documentGroupType, }) {
        if (!this.data.vat_id) {
            return true;
        }
        const userTaxRate = await this.getUserTaxRate();
        const taxCategoryId = await this.findTaxCategoryId();
        if (!userTaxRate) {
            return true;
        }
        return userTaxRate.isAllowed({
            sourceCountryId,
            targetCountryId,
            taxCategoryId,
            documentGroupType,
        });
    }
    async findTaxCategoryId() {
        const productCategory = await this.getProductCategory();
        return productCategory ? productCategory.data.tax_category_id : null;
    }
    /**
     * Calculations
     */
    calculate(options = {}) {
        this.calculateCost(options.priceMode);
        if ((typeof options.use_tax !== 'undefined' && options.use_tax) || this.data.use_tax) {
            this.setCalculatedTax(options);
        }
        else {
            this.setZeroTax();
        }
        this.calculateCIS(options);
        this.emit(businessCalculator_1.default.EVENTS.LINE_RECALCULATED, this.getData());
        return this.getData();
    }
    calculateCost(priceMode = 'sales_price') {
        let baseCost = this.data.unitcost;
        if (priceMode === 'cost_price' && this.data.cost_price) {
            baseCost = this.data.cost_price;
        }
        else if (this.data.sales_price) {
            baseCost = this.data.sales_price;
        }
        this.data.cost = Math.round(baseCost * this.data.quantity * businessCalculator_1.default.PRECISION_MULTIPLIER)
            / businessCalculator_1.default.PRECISION_MULTIPLIER;
    }
    setCalculatedTax(options = {}) {
        if (options.is_inclusive || this.data.is_inclusive) {
            this.data.vat = this.calculateIncludedTax();
            this.data.exclusive_cost = this.data.cost - this.data.vat;
        }
        else {
            this.data.vat = this.calculateTax();
            this.data.exclusive_cost = this.data.cost;
            this.data.cost = this.data.exclusive_cost + this.data.vat;
        }
    }
    calculateIncludedTax() {
        return math.calculateIncludedTax(this.data.cost, this.data.vat_rate);
    }
    calculateTax() {
        return math.calculateTax(this.data.cost, this.data.vat_rate);
    }
    setZeroTax() {
        this.data.vat = 0;
        this.data.vat_rate = 0;
        this.data.vat_id = undefined;
        this.data.exclusive_cost = this.data.cost;
    }
    calculateCIS(options = {}) {
        if (this.data.is_cis || options.cisEnabled) {
            this.data.cis_value = Math.round((this.data.exclusive_cost * (this.data.cis_rate / 100))
                * businessCalculator_1.default.PRECISION_MULTIPLIER) / businessCalculator_1.default.PRECISION_MULTIPLIER;
        }
    }
    async setCurrentTaxSettings() {
        const compData = (await this.getCompany()).data;
        const userTaxRate = await this.getUserTaxRate();
        this.data.is_category_required = compData.isCategoryRequired;
        this.data.use_tax = compData.vat_registered;
        this.data.is_inclusive = compData.tax_inclusive ? 1 : 0;
        if (userTaxRate) {
            this.data.vat_rate = userTaxRate.data.rate;
        }
    }
}
JobItem.Entity = entity_1.default;
JobItem.modelProperties = modelProperties_1.default;
exports.default = JobItem;
//# sourceMappingURL=../../../../src/models/jobItem/index.js.map